import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getListFromValues, hasChangedValues, getFormValue, changeItemsValue, getListItems } from '../../public/utility'
class ApplicationTypeSelect extends React.Component {
    state = {
        changedValues基本信息: {},
    }

    handlerSave = () => {
        const { onClose } = this.props
        const 申请类型 = getFormValue(this, '基本信息', '申请类型')
        if (申请类型) {
            onClose && onClose()
            switch (申请类型) {
                case '请假申请':
                    location.hash = `QYWX/OutApply/${0}`
                    break
                case '销假申请':
                    location.hash = `QYWX/LeaveCancelApply/${0}`
                    break
            }
        }
    }

    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }

    canSave = () => {
        return getFormValue(this, '基本信息', '申请类型')
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        return [
            { _radio: '', name: '申请类型', itemMinWidth: 40, minWidth: '95%', items: ['请假申请', '销假申请'], required: true }
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, id } = this.props
        const { errorMessage, bReadOnly } = this.state
        if (errorMessage) return <Message text={errorMessage} />
        const canSave = this.canSave()
        const bChanged = this.bChanged()
        return <Body data={this} maxWidth="700"
            controls={
                bReadOnly ?
                    [
                        { _button: bChanged && '取消' || '关闭', icon: '', handler: this.handlerClose },
                    ] : [
                        { _button: '确定', icon: '', handler: this.handlerSave, disabled: !(canSave && bChanged) },
                        { _button: bChanged ? '取消' : '关闭', icon: '', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly },
                ]}
        />
    }
}

export default connect()(ApplicationTypeSelect)